import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PageShell from "@/components/layout/PageShell";
import SERVICES from "@/lib/services";

const fade = {
  hidden: { opacity: 0, y: 22 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] } }),
};

export const ApplyPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const go = (s) => {
    if (s.key === "visa") navigate("/apply/visa");
    else navigate(s.to);
  };

  return (
    <PageShell>
      <div className="max-w-5xl mx-auto" data-testid="apply-hub">
        <div className="mb-8">
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-venka-green-light mb-2">
            {t("applyHub.title")}
          </p>
          <h1 className="font-serif text-3xl sm:text-4xl text-brand-gradient leading-tight">
            {t("applyHub.title")}
          </h1>
          <p className="text-slate-300 mt-2 max-w-2xl">{t("applyHub.subtitle")}</p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.button
                key={s.key}
                type="button"
                onClick={() => go(s)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-40px" }}
                variants={fade}
                custom={i}
                className="group text-left rounded-2xl border border-white/10 bg-card p-6 hover:border-venka-green/50 transition-colors"
                data-testid={`apply-service-${s.key}`}
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl brand-gradient text-white">
                  <Icon className="h-6 w-6" strokeWidth={1.8} />
                </span>
                <h3 className="mt-4 font-serif text-xl text-white">{t(`common.nav.${s.key}`)}</h3>
                <p className="mt-2 text-sm text-slate-400">{s.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-venka-green-light">
                  {t("visaCountries.start")}
                  <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </PageShell>
  );
};

export default ApplyPage;
